import axios from "axios";
import { toast } from "react-hot-toast";
import store from "../store";
import { logout } from "../store/authSlice";
import i18next from "../i18n"; // translate outside React

const axiosInstance = axios.create({});

// Route detectors
const isVerifyOtp = (url = "") => url.includes("/auth/supabase/verify-otp");
const isRequestOtp = (url = "") => url.includes("/auth/supabase/request-otp");

// Attach Authorization except where skipped upstream (optional)
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("vendorAuthToken");
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Route-scoped error messaging; always reject after toasting
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const code = error?.response?.data?.code;
    const url = error?.config?.url || "";

    // verify-otp: Only ever show OTP invalid on 401; suppress "not registered" here
    if (isVerifyOtp(url)) {
      if (status === 401) {
        toast.error(i18next.t("otpInvalid"), { toastId: "otp-invalid" });
      }
      // Do not logout or show "number not registered" for verify-otp
      return Promise.reject(error);
    }

    // // request-otp: If user truly not registered, show that single message
    // if (isRequestOtp(url)) {
    //   if (status === 404 || code === "USER_NOT_FOUND") {
    //     toast.error(i18next.t("numberNotRegistered"), { toastId: "num-not-registered" });
    //   }
    //   return Promise.reject(error);
    // }

    // Other routes: session handling without spamming toasts
    if (status === 401) {
      try {
        store.dispatch(logout());
      } catch {}
      // No toast here; let UI decide
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
